import { useContext } from "react";
import { useQuery } from '@tanstack/react-query';
import { IListPermissionsResponse } from "../../../logic/api";
import { SessionContext } from "../../../utility/useSession";

interface UsePermissionsOptions {
    enabled?: boolean;
}

export const usePermissions = (options: UsePermissionsOptions = {}) => {
    const { current: session } = useContext(SessionContext);

    const userUuid = session?.site?.user?.uuid;
    const tenantId = session?.site?.tenant?.id;

    return useQuery<IListPermissionsResponse | null, Error>({
        queryKey: ['permissions', userUuid, tenantId],
        queryFn: async () => {
            if (!session?.context) {
                throw new Error('Session context not available');
            }
            const response = await fetch(`${session.context.url}/rbac/listPermissions/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...session.context.headers,
                },
                body: JSON.stringify({}),
            });
            if (!response.ok) {
                throw new Error(`Failed to fetch permissions: ${response.statusText}`);
            }
            return response.json();
        },
        enabled: !!userUuid && !!tenantId && !!session?.context && (options.enabled !== false),
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
};